module.exports = __webpack_public_path__ + "img/0014.bdb6df85.jpg";